<template lang='pug'>
  .reward-modal
    .icon-container
      img.icon(:src='reward.icon')
    .details
      template(v-if='reward.tierExclusiveLabels.length === 0')
        .tier-label(v-text='')
      template(v-else)
        span.tier-label(
          v-for='label in reward.tierExclusiveLabels'
          v-text='label.text + " "'
          :style='{ color: label.hexCode }'
        )
      .brand-name(v-text='reward.brandName')
      .product-name(v-text='reward.productName')
      .show-points
        template(v-if="!discountable")
          .points(v-text='`${reward.points} ${$t("common.points")}`')
        template(v-else)
          span.original-points(v-text='`${reward.originalPoints} ${$t("common.points")}`')
          span.points(v-text='`${reward.points} ${$t("common.points")}`')
          span.discount-label(v-text='`(${reward.discountLabel})`')
      .editors-note(v-if='reward.editorsNote')
        .title(v-text='$t("account.rewardsBoutique.editorsNote")')
        .text(v-html='reward.editorsNote')

      template(v-if='isGuestUser')
        a.btn.sign-in(:href='"/rewards-boutique/#authentication"' v-text='$t("account.rewardsBoutique.signInToAddToCart")')
      template(v-else)
        AddRewardToBagButton.add-to-bag(
          :reward-id='reward.id'
          :is-redeemable='isRedeemable'
          :is-reward-added-to-bag='isRewardAddedToBag'
          @addToBag='handleClick(reward)'
        )
      hr.hr
      template(v-if='showCtaButton')
        router-link.btn.btn-white.router-link.full-details(
          :to='productShowRoute(reward)'
          v-text='$t("account.rewardsBoutique.viewFullDetails")'
          @click.native='handleClick(reward)'
        )
      .policy(v-text='policyDescription')
</template>

<script>
import AddRewardToBagButton from './add-reward-to-bag-button.vue'

export default {
  components: {
    AddRewardToBagButton
  },

  props: {
    reward: {
      type: Object,
      required: true
    },

    isRedeemable: Boolean,
    isGuestUser: Boolean,
    isRewardAddedToBag: Boolean
  },

  computed: {
    showCtaButton () {
      return (this.reward.productId && this.reward.points < 500)
    },
    policyDescription () {
      return (this.reward.tnc)
        ? this.reward.tnc
        : this.$t('account.rewardsBoutique.limitedQuantity', { points: this.reward.points })
    },
    discountable () {
      return this.reward.originalPoints && this.reward.points !== this.reward.originalPoints
    }
  },

  methods: {
    productShowRoute (reward) {
      return {
        name: 'products-show-variant',
        params: {
          id: reward.productSlugUrl || reward.productId,
          variantId: reward.variantSlugUrl
        }
      }
    },

    handleClick (reward) {
      $(`#reward${reward.id} .close`).click()
    }
  }
}
</script>

<style lang='scss' scoped>
  .reward-modal {
    clear: both;

    @include media-breakpoint-up(sm) {
      display: flex;
    }
  }

  .icon-container {
    @include media-breakpoint-up(sm) {
      flex: 1;
    }

    > .icon {
      height: auto;
      max-width: 100%;
    }
  }

  .details {
    @include media-breakpoint-up(sm) {
      flex: 1;
      margin-left: 20px;
    }

    > .tier-label {
      height: 16px;
      margin-top: 5px;
      font-size: 10px;
      font-weight: 500;
      letter-spacing: 1.5px;
      text-transform: uppercase;
      line-height: normal;
    }

    > .brand-name {
      @include font-weight-bold;
      text-transform: uppercase;
    }

    > .show-points {
      > .points, span.points {
        @include font-weight-bold;
        text-transform: capitalize;
        padding-right: 5px;
      }

      > .original-points {
        text-transform: capitalize;
        text-decoration: line-through;
        padding-right: 5px;
      }

      > span.discount-label {
        @include font-weight-bold;
        text-transform: capitalize;
        color: $brand-primary;
      }
    }

    > .sign-in {
      margin-top: 20px;
    }

    > .hr {
      margin-top: 25px;
      margin-bottom: 25px;
      opacity: 0.3;
    }

    > .full-details {
      display: block;
      width: 205px;
    }

    > .policy {
      margin-top: 20px;
      color: $grey-dark;
      font-size: 11px;
    }
  }

  .editors-note {
    margin-top: 20px;

    > .title {
      @include font-weight-medium;
    }
  }

  .add-to-bag {
    margin-top: 23px;
  }
</style>
